const serviceLinks = [
  "Asesoramiento y Consultoría",
  "Marketing Digital",
  "Creación de Webs con IA",
  "Gestión de Redes Sociales",
  "Dashboards y Análisis",
];

const socialLinks = [
  { icon: "ri-linkedin-fill", href: "#", label: "LinkedIn" },
  { icon: "ri-instagram-line", href: "#", label: "Instagram" },
  { icon: "ri-twitter-x-line", href: "#", label: "Twitter" },
  { icon: "ri-facebook-fill", href: "#", label: "Facebook" },
];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ background: "#000000" }}>
      {/* Top border */}
      <div className="w-full h-px" style={{ background: "linear-gradient(90deg, transparent, #C9A227/20, transparent)", borderTop: "1px solid #1a1a1a" }}></div>

      <div className="max-w-7xl mx-auto px-8 lg:px-16 pt-20 pb-10">

        {/* Main Footer Grid */}
        <div className="grid lg:grid-cols-12 gap-12 mb-16">

          {/* Brand Column */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/a0761e962eb5c291c08d71c2c83d99b3/61ecfeb16ca96e33a151f9b888933dc5.png"
                alt="Imperial Digital Logo"
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-white font-bold text-lg tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Imperial <span className="text-[#C9A227]">Digital</span>
                </div>
                <div className="text-gray-600 text-xs tracking-widest uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Marketing & Consultoría
                </div>
              </div>
            </div>

            <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-xs" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              Consultoría estratégica en marketing digital impulsada por inteligencia artificial. Transformamos marcas en referentes de su sector.
            </p>

            {/* Social Icons */}
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  rel="nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-[#2a2a2a] hover:border-[#C9A227]/50 text-gray-500 hover:text-[#C9A227] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services Column */}
          <div className="lg:col-span-3">
            <h4
              className="text-white text-xs font-bold tracking-widest uppercase mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <a href="#servicios" className="text-white">SERVICIOS</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {serviceLinks.map((service) => (
                <li key={service}>
                  <button
                    onClick={() => scrollTo("servicios")}
                    className="text-gray-500 hover:text-[#C9A227] text-sm transition-colors duration-200 cursor-pointer text-left"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Image Column */}
          <div className="lg:col-span-4">
            <h4
              className="text-white text-xs font-bold tracking-widest uppercase mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              <a href="#contacto" className="text-white">CONTACTO</a>
            </h4>
            <div className="flex flex-col gap-3 mb-8">
              {[
                { icon: "ri-mail-line", text: "imperialcardinal.investments@gmail.com" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#C9A227] text-sm`}></i>
                  </div>
                  <span className="text-gray-500 text-sm" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>

            {/* Footer Image */}
            <div className="rounded-xl overflow-hidden" style={{ height: "160px", width: "100%" }}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20dark%20luxury%20marketing%20office%20corporate%20premium%20team%20work%20minimalist%20gold%20accent%20modern%20sophisticated%20business%20environment%20spain&width=400&height=160&seq=footer-img-1&orientation=landscape"
                alt="Imperial Digital office"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#1a1a1a] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            © {new Date().getFullYear()} Imperial Digital. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            {["Privacidad", "Términos", "Cookies"].map((link) => (
              <a
                key={link}
                href="#"
                rel="nofollow"
                className="text-gray-600 hover:text-[#C9A227] text-xs transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
